import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsSection = () => {
  const statistics = [
  {
    id: 1,
    icon: "TrendingUp",
    label: "KA220-SCH in France",
    value: "28%",
    description: "Average funding success rate"
  },
  {
    id: 2,
    icon: "TrendingUp",
    label: "KA210-VET in Poland",
    value: "30%",
    description: "Average funding success rate"
  },
  {
    id: 3,
    icon: "TrendingUp",
    label: "KA220-ADU in Italy",
    value: "9%",
    description: "Average funding success rate"
  },
  {
    id: 4,
    icon: "TrendingUp",
    label: "KA210-YOU in Spain",
    value: "16%",
    description: "Average funding success rate"
  }];


  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">Selected Statistics from National Agencies

          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive coverage of the research funding ecosystem
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {statistics?.map((stat) =>
          <div
            key={stat?.id}
            className="bg-card border border-border rounded-xl p-6 text-center shadow-elevation-sm hover:shadow-elevation-md transition-all duration-300 ease-smooth">

              <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg mx-auto mb-4">
                <Icon name={stat?.icon} size={24} color="white" />
              </div>

              <div className="text-4xl font-heading font-bold text-white mb-2">
                {stat?.value}
              </div>

              <div className="text-sm font-semibold text-white mb-1">
                {stat?.label}
              </div>

              <div className="text-xs text-white">
                {stat?.description}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default StatisticsSection;